var NullTransaction,
    ObservableRead,
    ReadTransaction,
    WithObservableReads,
    _,
    __hasProp = {}.hasOwnProperty,
    __extends = function __extends(child, parent) {
  for (var key in parent) {
    if (__hasProp.call(parent, key)) child[key] = parent[key];
  }

  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
  child.__super__ = parent.prototype;
  return child;
};

NullTransaction = require('./NullTransaction');
_ = require('lodash');

ReadTransaction = function (_super) {
  __extends(ReadTransaction, _super);

  function ReadTransaction() {
    this.dirtyIds = {};
    this.dirtyScans = {};
    this.log = [];
  }

  ReadTransaction.prototype._extractFragment = function (doc) {
    if (!doc) {
      return null;
    }

    return {
      _id: doc._id,
      _version: doc._version
    };
  };

  ReadTransaction.prototype.get = function (collectionName, result, _id) {
    this.dirtyIds[collectionName] = this.dirtyIds[collectionName] || {};
    this.dirtyIds[collectionName][_id] = true;
    this.log.push(this._extractFragment(result));
    return result;
  };

  ReadTransaction.prototype.find = function (collectionName, result) {
    this.dirtyScans[collectionName] = true;
    this.log.push(result.map(this._extractFragment));
    return result;
  };

  ReadTransaction.prototype.findOne = function (collectionName, result) {
    this.dirtyScans[collectionName] = true;
    this.log.push(this._extractFragment(result));
    return result;
  };

  ReadTransaction.prototype.canPushTransaction = function () {
    return false;
  };

  return ReadTransaction;
}(NullTransaction);

ObservableRead = function () {
  function ObservableRead(db, func, context) {
    this.db = db;
    this.func = func;
    this.context = context;
    this.lastReadTransaction = null;
    this.lastValue = null;
    this.subscribers = [];
    this.changeListener = this.changeListener.bind(this);
    this.db.on('change', this.changeListener);
    this.rerunTransaction();
  }

  ObservableRead.prototype.subscribe = function (cb) {
    this.subscribers.push(cb);
    cb(this.lastValue);
    return this;
  };

  ObservableRead.prototype.dispose = function () {
    return this.db.removeListener('change', this.changeListener);
  };

  ObservableRead.prototype.rerunTransaction = function () {
    var nextReadTransaction, prevValue, value;
    nextReadTransaction = new ReadTransaction();
    value = this.db.withTransaction(nextReadTransaction, this.func, this.context);

    if (!this.lastReadTransaction || !_.isEqual(this.lastReadTransaction.log, nextReadTransaction.log)) {
      this.lastReadTransaction = nextReadTransaction;
      prevValue = this.lastValue;
      this.lastValue = value;
      return this.subscribers.forEach(function (cb) {
        cb(this.lastValue, prevValue);
      }, this);
    }
  };

  ObservableRead.prototype.changeListener = function (changeRecords) {
    var collectionName, dirtyIdsForCollection, documentFragment, documentFragments, i;

    if (!this.lastReadTransaction) {
      this.rerunTransaction();
      return;
    }

    for (collectionName in changeRecords) {
      if (this.lastReadTransaction.dirtyScans[collectionName]) {
        this.rerunTransaction();
        return;
      }

      dirtyIdsForCollection = this.lastReadTransaction.dirtyIds[collectionName] || {};
      documentFragments = changeRecords[collectionName];
      i = 0;

      while (i < documentFragments.length) {
        documentFragment = documentFragments[i];

        if (dirtyIdsForCollection[documentFragment._id]) {
          this.rerunTransaction();
          return;
        }

        i++;
      }
    }
  };

  return ObservableRead;
}();

WithObservableReads = {
  observe: function observe(func, context) {
    return new ObservableRead(this, func, context);
  }
};
module.exports = WithObservableReads;